import { ErrorResponse, Timestamp, TuettuKieli } from '@lemon/core/model/common'

export type NetsEnvironment = 'prod' | 'beta' | 'dev' | 'local-dev'

export interface StartNewStrongAuthenticationSession {
  action: ActionAfterAuthentication
}

export type PaymentDueType = 'heti' | 'erapaivana'

export interface StrongAuthenticationSessionInfo {
  avain: string
  state: string
  stateHash: string
  nonce: string
}

export interface NetsTunnistauduRequest {
  avain: string
  state: string
  stateHash: string
  code: string
  env: NetsEnvironment
  device?: string
  os?: string
  version?: string
}

export interface NetsTunnistauduResponse<T = any> {
  result: 'success' | 'failure'
  action: ActionAfterAuthentication
  data?: T
  resultCause?: NetsTunnistauduResponseResultCause
}

export enum NetsTunnistauduResponseResultCause {
  SSN_MISMATCH = 'ssn-mismatch',
}

export interface TallennaUserKycRequest {
  kansallisuus: string
  pep: boolean
}

export interface TallennaUserKycResponse extends ErrorResponse<'data-missing' | 'unknown-error'> {}

export type ActionAfterAuthentication =
  | 'continue-welcome'
  | 'continue-standalone-dialog'
  | 'continue-document-sign'
  | 'continue-payment-approval'
  | 'continue-aineiston-lataus'
  | 'continue-tilintarkastaja-tunnistautuminen'
  | 'continue-tilintarkastaja-kirjautuminen'
export type ActionAfterAuthenticationLemonaid = Extract<
  ActionAfterAuthentication,
  'continue-welcome' | 'continue-standalone-dialog' | 'continue-document-sign' | 'continue-payment-approval' | 'continue-aineiston-lataus'
>
export type ActionAfterAuthenticationLemonator = Extract<ActionAfterAuthentication, 'continue-tilintarkastaja-tunnistautuminen' | 'continue-tilintarkastaja-kirjautuminen'>

export type InGroupeAuthMethod = 'fi_mobiilivarmenne' | 'nordea' | 'opbank' | 'danske' | 'handelsbanken' | 'aland' | 'sbank' | 'aktia' | 'popbank' | 'savingsbank' | 'omasp'

export interface AloitaTunnistautuminenJaAnnaUrlRequest {
  action: ActionAfterAuthentication
  authMethod: InGroupeAuthMethod
  kieli: TuettuKieli
  env: NetsEnvironment
}

export interface AloitaTunnistautuminenJaAnnaUrlResponse {
  url: string
  avain: string
  state: string
}

export interface AloitaTunnistautuminenMaksutJaAnnaUrlRequest {
  action: ActionAfterAuthentication
  authMethod: InGroupeAuthMethod
  kieli: TuettuKieli
  env: NetsEnvironment
  maksut: string[]
  dueType: PaymentDueType
  paymentConfigId: string
}

export interface AloitaTunnistautuminenAineistonLatausJaAnnaUrlRequest {
  action: ActionAfterAuthentication
  authMethod: InGroupeAuthMethod
  kieli: TuettuKieli
  env: NetsEnvironment
  token: string
}

export interface StrongAuthenticationSessionHistory {
  asiakasAvain: string
  kayttajaAvain: string
  logTime: Timestamp
  step: StrongAuthenticationSessionStep
  details: string
  env: NetsEnvironment
}

export type StrongAuthenticationSessionStep = 'redirect' | 'returned' | 'success' | 'error'
